<template>
  <div>
    <recharge-record-pc class="pc-show" :init-data="initData" :hasFetch="hasFetch"></recharge-record-pc>
    <recharge-record-m class="phone-show" :init-data="initData" :hasFetch="hasFetch"></recharge-record-m>
  </div>
</template>

<script>
  import rechargeRecordPc from '../../components/rechargeRecord/RechargeRecordPc.vue'
  import rechargeRecordM from '../../components/rechargeRecord/RechargeRecordM.vue'

  export default {
    name: 'recharge-record-view',
    components: {rechargeRecordPc, rechargeRecordM},
    data() {
      return {
        initData: '',
        hasFetch: false
      }
    },
    created() {
      this.getInitRecordsData()
    },
    methods: {
      getInitRecordsData() {
        this.$http.get('api/topup-records?page=1').then((response) => {
          this.initData = response
          this.hasFetch = true
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  @media screen and (min-width: 768px) {
    .phone-show {
      display: none;
    }
  }

  @media screen and (max-width: 767px) {
    .pc-show {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// RechargeRecord.vue?cff57df2